import { memo } from 'react';
import type { FC } from 'react';
import classes from './Point.module.scss';

interface Props {
  number: string;
  title: string | React.ReactNode;
  description?: string | React.ReactNode; 
  children?: React.ReactNode;
  contentPart?: string;
  className?: string;
  classes?: {
    root?: string;
  };
}

export const Point: FC<Props> = memo(function Point({ number, title, description, children, contentPart, className = '', classes: customClasses = {} }) {
  return (
    <div className={`${customClasses.root || ''} ${className} ${classes.card}`}>
      <div className={classes.titleWrap}>
        <div className={classes.number}>{number}</div>
        <div className={classes.title}>{title}</div>
        </div>
      <div className={classes.description}>{description}</div>
      {children} 
    </div>
  );
});

